export default __webpack_public_path__ + "static/media/Merritt_Villas_Site_Plan.1b923835.webp";